import classes from './sectionTitle.module.scss';

const SectionTitle = ({ id, primaryText, secondaryText }) => {
    return (
        <h2 className={classes.Title} id={id}>
            <span className={classes.Accent}>{primaryText}</span>
            {secondaryText && <span className={classes.Main}>{secondaryText}</span>}
        </h2>
    );
};

export default SectionTitle;
